import {
  booleanAttribute,
  Component,
  inject,
  input,
  signal,
} from '@angular/core';
import { WishListDataService } from '../../../services/witsh-list-data.service';
import { I18nPluralPipe } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'wish-list-nav',
  imports: [I18nPluralPipe, RouterLink],
  templateUrl: './wish-list-nav.component.html',
})
export class WishListNavComponent {
  isMobile = input(false, { transform: booleanAttribute });
  private router = inject(Router);
  wishListDataService = inject(WishListDataService);
  wishListMap = signal({
    '=1': 'Nueva',
    other: 'Nuevas',
  });

  viewWishList(wishList: string) {
    this.router.navigate(['/wishlist'], {
      queryParams: { name: wishList },
    });
  }
}
